import {Base} from "@/api/Base"

export class AdvisorList extends Base {
    path = "advisor/list"
}